module.exports = __webpack_public_path__ + "img/stripe.7c307a72.svg";